/**
 * Classe usata per la gestione della chat ai all'interno della pagina info apartment dell'ospite
 */

import MarkdownRenderer from "../common/markdown_renderer";

class ApartmentInfo {
  constructor(api_url, apt_id) {
    this.api_url = api_url;
    this.payload = {
      session_id: null,
      text: null,
      stream: true,
      context: {
        lang: null,
        apt_id: apt_id
      },
      agent_code: "CHAT_BOT_APT"
    };
    this.apt_id = apt_id;
    this.activeStar = null;
    this.controller = null;
  }

  init() {
    this.initEvents();
  }

  async sendMessage() {
    const textarea = document.querySelector("#textarea");
    const message = textarea.value.trim();
    if (message) {
      this.renderMessage("user", message);
      const aiChatContainer = document.getElementById("ai-chat-container");
      if (!aiChatContainer.classList.contains("open")) {
        aiChatContainer.classList.add("open");
      }
      this.renderLoading();
      this.scrollContainer();
      textarea.value = "";
      this.payload.text = message;
      this.payload.context.lang =
        typeof I18n !== "undefined" && I18n.locale
          ? I18n.locale
          : (navigator.language || "en").split("-")[0].toLowerCase();
      try {
        document.querySelector("#stop").classList.add("show");
        document.querySelector("#send").classList.remove("show");
        if (this.controller) {
          this.controller.abort();
        }
        this.controller = new AbortController();
        const response = await fetch(`${this.api_url}/ui/v1/agent_ai/chat`, {
          method: "POST",
          body: JSON.stringify(this.payload),
          headers: {
            "Content-Type": "application/json"
          },
          signal: this.controller.signal
        });
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.error);
        } else {
          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = "";
          let id = crypto.randomUUID();
          let accumulated = "";
          let agentElement = null;
          document.querySelector(".rating").classList.add("show");
          this.removeLoading();
          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            // Accumula testo SSE nel buffer
            buffer += decoder.decode(value, { stream: true });

            // Ogni evento SSE è separato da una riga vuota (\n\n)
            const events = buffer.split("\n\n");
            buffer = events.pop() || ""; // conserva eventuale evento incompleto

            for (const evt of events) {
              const lines = evt.split("\n").filter(Boolean);
              const eventLine = lines.find(l => l.startsWith("event:"));
              const dataLine = lines.find(l => l.startsWith("data:"));
              if (!dataLine) continue;

              const eventType = eventLine ? eventLine.slice(6).trim() : null;
              if (!eventType) continue;

              const jsonPart = dataLine.slice(5).trim(); // dopo "data:"

              try {
                const data = JSON.parse(jsonPart);
                if (eventType === "token") {
                  const delta = data.delta || "";
                  if (!delta) continue;

                  // Crea l'elemento dell'agente una sola volta
                  if (!agentElement) {
                    this.renderMessage("agent", "", id);
                    agentElement = document.getElementById(id);
                    if (!agentElement) continue;
                  }

                  // Accumulate text and apply markdown to entire response
                  accumulated += delta;
                  console.log(
                    "MarkdownRenderer:",
                    MarkdownRenderer,
                    "accumulated:",
                    accumulated
                  );
                  const html = MarkdownRenderer.render(accumulated);
                  console.log("HTML result:", html);
                  agentElement.innerHTML = html;
                  this.scrollContainer();
                } else if (eventType === "done") {
                  // Arriva { "session_id": "...", "sources": [...] }
                  this.payload.session_id = data.session_id;
                }
              } catch (e) {
                console.error("Errore parsing SSE", e, jsonPart);
              }
            }
          }
          document.querySelector("#stop").classList.remove("show");
          document.querySelector("#send").classList.add("show");
        }
      } catch (error) {
        this.removeLoading();
        if (error.name !== "AbortError") {
          this.renderAlert("inline", error.message, 0);
        }
        document.querySelector("#stop").classList.remove("show");
        document.querySelector("#send").classList.add("show");
      }
    } else {
      this.removeLoading();
      this.renderAlert(
        "global",
        I18n.t("apartments_page.apartment_page.ai_text_required"),
        3000
      );
    }
  }

  async sendRating(index) {
    let rating = index + 1;
    if (rating) {
      try {
        const response = await fetch(
          `${this.api_url}/ui/v1/agent_ai/evaluate_chat`,
          {
            method: "POST",
            body: JSON.stringify({
              session_id: this.payload.session_id,
              vote: rating
            }),
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error);
        } else {
          this.renderAlert("global", data.message, 3000, "success");
        }
      } catch (error) {
        this.removeLoading();
        this.renderAlert("global", error.message, 0);
      }
    }
  }

  resetChat() {
    document.querySelector("#chat-container").innerHTML = "";
    document.querySelector("#textarea").value = "";
    document
      .querySelectorAll(".fa-star")
      .forEach(s => s.classList.remove("active"));
    document.querySelector(".rating").classList.remove("show");
    this.controller.abort();
    const aiChatContainer = document.getElementById("ai-chat-container");
    if (aiChatContainer.classList.contains("open")) {
      aiChatContainer.classList.remove("open");
    }
    this.payload = {
      session_id: null,
      text: null,
      stream: true,
      context: {
        lang: null,
        apt_id: this.apt_id
      },
      agent_code: "CHAT_BOT_APT"
    };
    this.activeStar = null;
  }

  stopChat() {
    this.controller.abort();
    document.querySelector("#stop").classList.remove("show");
    document.querySelector("#send").classList.add("show");
  }

  loading() {
    const div = document.createElement("div");
    div.classList.add("loading-ai");
    div.id = "loading-ai";
    div.innerHTML = '<i class="fa-duotone fa-solid fa-loader"></i>';
    return div;
  }

  alert(text, className) {
    const div = document.createElement("div");
    div.classList.add(className);
    div.id = "alert-ai";
    div.innerHTML = text;
    return div;
  }

  message(type, text, id = null) {
    const div = document.createElement("div");
    if (id) {
      div.id = id;
    }
    div.classList.add(type);
    div.style.whiteSpace = "normal";
    div.innerHTML = text;
    return div;
  }

  removeLoading() {
    if (document.querySelector("#loading-ai")) {
      document.querySelector("#loading-ai").remove();
    }
  }

  // type: 'global' | 'inline'
  renderAlert(type, text, time, className = "error") {
    if (type === "global") {
      document
        .querySelector("#main-container")
        .prepend(this.alert(text, className));
      if (time) {
        setTimeout(() => {
          document.querySelector("#alert-ai").remove();
        }, time);
      }
    } else {
      this.renderMessage("error-inline", text);
    }
  }

  // type: 'user' | 'agent' | 'error-inline'
  renderMessage(type, text, id = null) {
    const existingElement = id ? document.getElementById(id) : null;

    if (existingElement) {
      existingElement.innerHTML += MarkdownRenderer.render(text);
    } else {
      document
        .querySelector("#chat-container")
        .append(this.message(type, MarkdownRenderer.render(text), id));
    }
  }
  renderLoading() {
    document.querySelector("#chat-container").append(this.loading());
  }

  scrollContainer() {
    document.querySelector("#chat-container").scrollTo({
      top: document.querySelector("#chat-container").scrollHeight
    });
  }

  addEventClass(elements, index, className) {
    elements.forEach((s, i) => {
      if (i <= index) {
        s.classList.add(className);
      } else {
        s.classList.remove(className);
      }
    });
  }

  initEvents() {
    document
      .querySelector("#send")
      .addEventListener("click", () => this.sendMessage());
    document
      .querySelector("#stop")
      .addEventListener("click", () => this.stopChat());
    document
      .querySelector("#reset")
      .addEventListener("click", () => this.resetChat());
    document.querySelector("#textarea").addEventListener("keydown", e => {
      if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault();
        this.sendMessage();
      }
    });
    const stars = document.querySelectorAll(".fa-star");

    // Logica colore stars suggerita da Kiro
    stars.forEach((star, index) => {
      star.addEventListener("mouseenter", () => {
        stars.forEach(s => s.classList.remove("active"));
        this.addEventClass(stars, index, "hover");
      });
      star.addEventListener("click", () => {
        this.activeStar = index;
        this.addEventClass(stars, index, "active");
        this.sendRating(index);
      });
    });
    document.querySelector(".rating").addEventListener("mouseleave", () => {
      stars.forEach(s => s.classList.remove("hover"));
      if (this.activeStar !== null) {
        this.addEventClass(stars, this.activeStar, "active");
      }
    });
  }
}

export default ApartmentInfo;
